import { render, staticRenderFns } from "./PrivateViewPage.vue?vue&type=template&id=0c596314&"
import script from "./PrivateViewPage.vue?vue&type=script&lang=js&"
export * from "./PrivateViewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports